import { media, P, TertiaryButton } from 'ia-react-core';
import { Section } from 'omni-package-react-core';
import styled from 'styled-components';

export const StyledButton = styled(TertiaryButton)`
  margin-left: auto;
  margin-top: 14px;

  ${media.sm`
    margin-bottom: 4px;
    margin-top: 0px;
  `}
`;
export const StyledP = styled(P)`
  margin-bottom: 0px;
  margin-top: 0px;
`;
export const StyledSection = styled(Section)`
display: block;
`;
export const StyledDivBlock = styled.div`
flex: 1;
max-width: 70%;
`;
export const StyledDivButton = styled.div`
`;
export const StyledDivContainer = styled.div`
 display: flex;
 flex-direction:column;
  
  ${media.sm`
  flex-direction:row;
  justify-content: space-between;
  `}
`;
